<template>

  <div style="" v-show="isShow">
    <div id='neirong'  >
         <div class='cbo' style="margin-top:90px;font-size:23px;color:red"> 
           注：以下红色项为必填项
         </div>
         <div class='cbo' style="margin-top:10px;font-size:23px;margin-bottom:-30px">  1. 委托人Client 
            <div style="float:right;margin-right:5%">合同编号：{{data.serialNumber}}</div>
         </div>
         <div class='cbo'  >  <table>
              <tr>
                <td colspan="2"><span class="color">名称Name：</span> <input :readonly="isRedeoly"    size="medium" v-model="data.clientName"  style="width:80%"></td>
                <td colspan="2"><span class="color">地址Address：</span> <input :readonly="isRedeoly"   v-model="data.clientAddr" style="width:80%"></td>
              </tr>
              <tr>
                <td><span class="color">联系人Contact：</span> <input :readonly="isRedeoly"   v-model="data.clientContacts" style="width:60%" ></td>
                <td><span class="color">电话Phone：</span> <input :readonly="isRedeoly"   v-model="data.clientPhone" style="width:60%"></td>
                <td><span class="color">邮箱E-mail：</span> <input :readonly="isRedeoly"   v-model="data.clientMail" style="width:60%"></td>
                <td>传真Fax：<input :readonly="isRedeoly"   v-model="data.clientFax" style="width:60%"></td>
              </tr>
          </table> </div>
  
         <div class='cbo' style="margin-top:30px;font-size:23px;margin-bottom:-30px"> 2. 生产者（制造商）Manufacturer（ 
            <el-button :disabled="isRedeoly"   type="primary" size="small" @click="
                                            data.producerName=data.clientName;
                                            data.producerAddr=data.clientAddr;
                                            data.producerContacts=data.clientContacts;
                                            data.producerPhone=data.clientPhone;
                                            data.producerMail=data.clientMail;
                                            data.producerFax=data.clientFax; ">同委托方</el-button>
          ）
       </div>
         <div class='cbo'> <table>
              <tr>
                <td colspan="2">名称Name： <input :readonly="isRedeoly"   v-model="data.producerName"  style="width:80%"></td>
                <td colspan="2">地址Address：<input :readonly="isRedeoly"   v-model="data.producerAddr" style="width:80%"></td>
              </tr>
              <tr>
                <td>联系人Contact：<input :readonly="isRedeoly"   v-model="data.producerContacts" style="width:60%" ></td>
                <td>电话Phone：<input :readonly="isRedeoly"   v-model="data.producerPhone" style="width:60%"></td>
                <td>邮箱E-mail：<input :readonly="isRedeoly"   v-model="data.producerMail" style="width:60%"></td>
                <td>传真Fax：<input :readonly="isRedeoly"   v-model="data.producerFax" style="width:60%"></td>
              </tr>
          </table> </div>
  
          <div style="margin-top:30px;font-size:23px;margin-bottom:-30px" class='cbo'>  3. 生产企业Factory（ 
            <el-button :disabled="isRedeoly"   type="primary" size="small" @click="
                                            data.factoryName=data.clientName;
                                            data.factoryAddr=data.clientAddr;
                                            data.factoryContacts=data.clientContacts;
                                            data.factoryPhone=data.clientPhone;
                                            data.factoryMail=data.clientMail;
                                            data.factoryFax=data.clientFax;">同委托方</el-button>） </div>
         <div class='cbo'> <table>
              <tr>
                <td colspan="2">名称Name： <input :readonly="isRedeoly"   v-model="data.factoryName"  style="width:80%"></td>
                <td colspan="2">地址Address：<input :readonly="isRedeoly"   v-model="data.factoryAddr" style="width:80%"></td>
              </tr>
              <tr>
                <td>联系人Contact：<input :readonly="isRedeoly"   v-model="data.factoryContacts" style="width:60%" ></td>
                <td>电话Phone：<input :readonly="isRedeoly"   v-model="data.factoryPhone" style="width:60%"></td>
                <td>邮箱E-mail：<input :readonly="isRedeoly"   v-model="data.factoryMail" style="width:60%"></td>
                <td>传真Fax：<input :readonly="isRedeoly"   v-model="data.factoryFax" style="width:60%"></td>
              </tr>
          </table> </div>
  
          <div class='cbo' style="margin-top:30px;font-size:23px;margin-bottom:-30px">  4. 代理方Agent	 </div>
         <div class='cbo'> <table>
              <tr>
                <td colspan="2">名称Name： <input :readonly="isRedeoly"   v-model="data.agentName"  style="width:80%"></td>
                <td colspan="2">地址Address：<input :readonly="isRedeoly"   v-model="data.agentAddr" style="width:80%"></td>
              </tr>
              <tr>
                <td>联系人Contact：<input :readonly="isRedeoly"   v-model="data.agentContacts" style="width:60%" ></td>
                <td>电话Phone：<input :readonly="isRedeoly"   v-model="data.agentPhone" style="width:60%"></td>
                <td>邮箱E-mail：<input :readonly="isRedeoly"   v-model="data.agentMail" style="width:60%"></td>
                <td>传真Fax：<input :readonly="isRedeoly"   v-model="data.agentFax" style="width:60%"></td>
              </tr>
          </table> </div>
  
  
          <div class='cbo' style="margin-top:30px;font-size:23px;margin-bottom:-30px">  5. 交费方Payer（
             <el-button :disabled="isRedeoly"   type="primary" size="small" @click="
                                            data.payerName=data.clientName;
                                            data.payerAddr=data.clientAddr;
                                            data.payerContacts=data.clientContacts;
                                            data.payerPhone=data.clientPhone;
                                            data.payerMail=data.clientMail;
                                            data.payerFax=data.clientFax;">同委托方</el-button>
             <el-button :disabled="isRedeoly"   type="primary" size="small" @click="
                                            data.payerName=data.producerName;
                                            data.payerAddr=data.producerAddr;
                                            data.payerContacts=data.producerContacts;
                                            data.payerPhone=data.producerPhone;
                                            data.payerMail=data.producerMail;
                                            data.payerFax=data.producerFax;">同生产企业</el-button>
             <el-button :disabled="isRedeoly"   type="primary" size="small" @click="
                                            data.payerName=data.agentName;
                                            data.payerAddr=data.agentAddr;
                                            data.payerContacts=data.agentContacts;
                                            data.payerPhone=data.agentPhone;
                                            data.payerMail=data.agentMail;
                                            data.payerFax=data.agentFax;">同代理方</el-button>
           ） </div>
         <div class='cbo'> <table>
              <tr>
                <td colspan="2"><span class="color">名称Name：</span> <input :readonly="isRedeoly"    v-model="data.payerName"  style="width:80%"></td>
                <td colspan="2"><span class="color">地址Address：</span> <input :readonly="isRedeoly"    v-model="data.payerAddr" style="width:80%"></td>
              </tr>
              <tr>
                <td><span class="color">联系人Contact：</span> <input :readonly="isRedeoly"   v-model="data.payerContacts" style="width:60%" ></td>
                <td><span class="color">电话Phone：</span> <input :readonly="isRedeoly"   v-model="data.payerPhone" style="width:60%"></td>
                <td><span class="color">邮箱E-mail：</span> <input :readonly="isRedeoly"   v-model="data.payerMail" style="width:60%"></td>
                <td>传真Fax：<input :readonly="isRedeoly"   v-model="data.payerFax" style="width:60%"></td>
              </tr>
              <tr>
                <td colspan="4" style="overflow:visible;">  
               <span class="color"> 付款方式：</span>
                  <template>
                        <el-radio :disabled="isRedeoly"    v-model="data.paymentMethod"  label="1">汇款remittance</el-radio>
                        <el-radio :disabled="isRedeoly"   v-model="data.paymentMethod"  label="2">支票Check</el-radio>
                        <el-radio :disabled="isRedeoly"    v-model="data.paymentMethod" label="3">其他Other：</el-radio>
                  </template>
                  <input  v-model="data.paymentMethodOrder" size="10" :style="inputStyle"   :readonly="(isRedeoly||data.paymentMethod!=='3')"   >
                 <span class="color"> 收到《收费通知单》在 <el-date-picker :disabled="isRedeoly"  v-model="data.payDate"  type="date" @change="data.payDate = initTime(data.payDate)"  placeholder="选择日期"></el-date-picker> 前或按合同约定时间内付款</span>
                </td>
              </tr>
          </table> </div>
         <div  class='cbo' style="margin-top:30px;font-size:23px;overflow:visible">  6. 样品信息Sample Information  </div>
          <div class="cbo">
            <table>
              <tr>
                <th width="10%" >序号<br>Serial Number </th>
                <th width="20%" style="color: red;"> 样品名称<br>Product</th>
                <th width="20%" style="color: red;">样品型号<br>Model No. </th>
                <th  width="13%" style="color: red;"> 样品规格<br>Specification </th>
                <th  width="13%">样品描述<br>Description </th>
                <th  width="8%"> 商标<br>Trademark</th>
                <th   width="8%" style="color: red;"> 数量<br>Quantity</th>
                <th   width="8%"><el-button :disabled="isRedeoly" type="primary" size="small" @click="data.subData.push({order:'',name:'',specs:'',trademark:'',number:''})">添加样品信息</el-button></th>
              </tr>
              <tr v-for="(item,i) in data.subData" :key="i">
                  <td> {{data.subData[i].order = (i+1)}}  </td>
                  <td><input :readonly="isRedeoly"  v-model="data.subData[i].name" style="width: 99%" ></td><!-- 样品名字-->
                  <td><input :readonly="isRedeoly"  v-model="data.subData[i].specs" style="width: 99%" ></td><!-- 样品型号-->
                  <td><input :readonly="isRedeoly"  v-model="data.subData[i].kind" style="width: 99%" ></td><!-- 样品规格-->
                  <td><input :readonly="isRedeoly"  v-model="data.subData[i].describe" style="width: 99%" ></td><!-- 样品描述-->
                  <td><input :readonly="isRedeoly"  v-model="data.subData[i].trademark" style="width: 99%" ></td><!-- 样品商标-->
                  <td><input :readonly="isRedeoly"  v-model="data.subData[i].number" style="width: 99%"  placeholder="请输入整数"  @input="data.subData[i].number= data.subData[i].number.replace(/[^\d]/g,'')" ></td><!-- 样品数量-->
                  <td> 
                    <el-button :disabled="isRedeoly"  type="primary" size="small" @click="data.subData.splice(i,1)">删除</el-button> 
                  </td>
              </tr>
              <tr>
                <td colspan="8">&nbsp;&nbsp;&nbsp;&nbsp;提供的配件或资料： <input :readonly="isRedeoly"  v-model="data.providePartsMaterial" size="100"  ></td>  
              </tr>
              <tr>
                <td colspan="8" style="overflow:visible">
                  <span style="font-size:18px;"> &emsp; <span class="color"> 样品寄送方式： </span></span>
                  <template>
                        <el-radio :disabled="isRedeoly"    v-model="data.simpleSubmitMethod"  label="1">自送</el-radio>
                        <el-radio :disabled="isRedeoly"    v-model="data.simpleSubmitMethod"  label="2">邮寄</el-radio>
                        <el-radio :disabled="isRedeoly"    v-model="data.simpleSubmitMethod"  label="4">现场测试，无样交接</el-radio>
                  </template>
                </td>  
              </tr>
              <tr>
                <td colspan="8" rowspan="2" style="overflow:visible;padding: 10px;line-height: 35px;">
                  <span style="font-size:18px;color: red;"> &emsp;  试验后样品处理（如不勾选，默认销毁）：<br>  </span>&emsp;
                  <template>
                        <el-radio :disabled="isRedeoly"    v-model="data.sampleHandle"  label="6" >到付寄回
                          <span v-show="data.sampleHandle=='6'">（ 
                          <template >
                                <el-radio :disabled="isRedeoly"    v-model="data.sampleHandleReturn"  label="1">同委托人 </el-radio>
                                <el-radio :disabled="isRedeoly"    v-model="data.sampleHandleReturn"  label="2">同生产企业</el-radio>
                                <el-radio :disabled="isRedeoly"    v-model="data.sampleHandleReturn"  label="3">同代理方</el-radio>
                                <el-radio :disabled="isRedeoly"    v-model="data.sampleHandleReturn"  label="4">同交费方</el-radio>
                                <el-radio :disabled="isRedeoly"    v-model="data.sampleHandleReturn"  label="5">其他</el-radio>
                          </template>
                          <input  v-model="data.sampleHandleReturnOther" size="60"  v-if="data.sampleHandleReturn=='5'"   :readonly="(isRedeoly||data.sampleHandleReturn!=='5')"  :style="sampleHandleReturnOtherStyle" > 
                          ）
                          </span>
                       </el-radio><br>
                       &emsp;&nbsp;<el-radio :disabled="isRedeoly"    v-model="data.sampleHandle"  label="2">合同完成后一个月内自取（超期视为主动弃置，按销毁处置）</el-radio>
                        <el-radio :disabled="isRedeoly"    v-model="data.sampleHandle"  label="3">实验室销毁</el-radio>
                  </template>
                  </td>
              </tr>
              <tr>
              </tr>
          </table>
          </div>
  
          <div class='cbo' style="margin-top:30px;font-size:23px;margin-bottom:-30px"> 7. 检验检测要求Inspection and Testing Requirements	 </div>
          <div class='cbo' style="text-align: center"> <table>
              <tr>
                <td rowspan="2" width="40%" style="color: red;" >检验检测依据<br> Testing Basis</td>
                <td rowspan="2" style="padding:10px">  
                  <el-input maxlength="3800" :readonly="isRedeoly" type="textarea" v-model="data.basis"  :autosize="{ minRows: 4, maxRows:4 }" > </el-input>
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td rowspan="2" style="color: red;"  >检验检测项目<br> Test Items</td>
                <td rowspan="2" style="padding:10px">
                  <el-input maxlength="3800" :readonly="isRedeoly" type="textarea" v-model="data.items"  :autosize="{ minRows: 4, maxRows:4 }" > </el-input>
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td rowspan="2"  style="color: red;">检验检测条件及要求 <br>Technical Conditions</td>
                <td rowspan="2" style="padding:10px">
                  <el-input maxlength="3800" :readonly="isRedeoly" type="textarea" v-model="data.conditionsRequirements" :autosize="{ minRows: 4, maxRows:4 }" > </el-input>
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td  style="overflow:visible">
                 <span class="color">如需分包：</span>
                  <template>
                    <el-radio :disabled="isRedeoly"    v-model="data.agreeSubcontract"  label="1">同意</el-radio>
                    <el-radio :disabled="isRedeoly"    v-model="data.agreeSubcontract"  label="0">不同意</el-radio>
                  </template>
              </td> 
              <td style="overflow:visible">
                <span class="color">该检验是否与诉讼有关：</span>
                  <template>
                    <el-radio :disabled="isRedeoly"    v-model="data.lawsuit"  label="0">否</el-radio>
                    <el-radio :disabled="isRedeoly"    v-model="data.lawsuit"  label="1"> 是（按诉讼委托流程进行）</el-radio>
                </template>
              </td>
             </tr>
             <tr>
                <td rowspan="2"  >附件(<span style="font-size:13px;color:red;font-weight:bold"><i class="el-icon-warning"></i>:重名只会上传成功一个,后上传的会覆盖以前上传的,单个文件最大10M</span>)</td>
                <td rowspan="2" > 
                        <div v-if="!isRedeoly"  style="float:left;width:350px;padding:20px;text-align: left;">
                            <el-upload   action="https://127.0.0.1/posts/" :on-remove='removeFile'  multiple :before-upload="beforeAvatarUpload" :http-request="upload"  :limit="10" >
                             <el-button  slot="trigger" size="small" type="primary">选取文件</el-button><br>
                            </el-upload>
                        </div>
                        <div style="float:left;;padding:20px;text-align: left; width: 90%;">
                        <a v-for="(item,i) in data.attachMent" :key="i"   v-show="item.type!=='delete'" style ='font-size:15px;padding-top:0px;float:left' class="el-upload-list__item-name" >
                          <div style="float:left;width:300px; overflow:hidden; white-space:nowrap; text-overflow:ellipsis;"> <span> 
                              <el-tooltip class="item" effect="dark" :content="item.fileName" placement="bottom">
                              <i class="el-icon-document" style="color:blue;">&nbsp;{{item.fileName}}</i>
                              </el-tooltip>
                            </span>
                          </div>
                          <div style="float:left;font-size:20px;"> <span>  <a :href= '"https://fw.ceprei.com/service/conSgin/downFile?fileId="+item.fileId+"&fileName="+item.fileName'><i style="color:#32cd32;" class="el-icon-download" ></i></a></span></div>
                          <div style="float:left;font-size:20px;"> <span v-if="!isRedeoly" > <span  style="cursor:pointer" href="" @click="deleteFile(item)" ><i class="el-icon-circle-close" style="color:red"></i></span></span></div>
                        </a>
                       </div>
                </td>
              </tr>
              <tr></tr>
          </table></div>
    </div>
        
       <div class ='divcenter' style="margin-top:30px;font-size:23px;  float:right;margin-right:14.6%">
        8. 报告要求Report Requirements
        </div>
         <div class ='divcenter' style="font-size:20px" >
            <table>
              <tr>
                <td colspan="1" style="overflow:visible;"><span class="color">报告形式：</span>
                </td>
                <td colspan="1" style="overflow:visible;">
                    <template>
                    <el-checkbox-group v-model="data.reportType" :disabled="isRedeoly">
                        <el-checkbox  label="1">中文</el-checkbox>
                        <el-checkbox label="2">英文（加收费用）</el-checkbox>
                        <el-checkbox label="4">不出报告</el-checkbox>
                      </el-checkbox-group>
                  </template>
                </td>
                <td colspan="1" style="overflow:visible;"><span class="color">报告类别：</span>
                </td>
                <td colspan="1" style="overflow:visible;">
                   <template>
                    <el-checkbox-group v-model="data.reportForm" :disabled="isRedeoly">
                         <el-checkbox   label="1">电子版（默认）</el-checkbox>
                        <el-checkbox label="2">纸质版，需额外收取费用(自取)</el-checkbox>
                        <el-checkbox  label="3">纸质版，需额外收取费用(快递) </el-checkbox>
                      </el-checkbox-group>
                  </template>
                </td>
              </tr>
              <tr>
                <td  style="overflow:visible;">报告标识：
                </td>
                <td  style="overflow:visible;">
                  <template>
                        <el-checkbox-group v-model="data.cmaCnas" :disabled="isRedeoly">
<!--                         <el-checkbox  label="CMA"> CMA</el-checkbox>-->
                         <el-checkbox  label="CNAS">CNAS</el-checkbox>
                         <el-checkbox  label="无">无</el-checkbox>
                         <el-checkbox  label="其他" >其他</el-checkbox>
                          <input  style="border-bottom:solid red;  height:20px;width: 130px"  v-show="data.cmaCnas.includes('其他')"  v-model="data.cmaCnasOther" size="60"   :readonly="isRedeoly"   >
                       </el-checkbox-group>

                  </template>
                </td>
                <td  style="overflow:visible;">服务要求：
                 
                </td>
                <td  style="overflow:visible;">
                  <template>
                        <el-radio :disabled="isRedeoly"    v-model="data.serviceRequitements"  label="1">正常（默认）</el-radio>
                        <el-radio :disabled="isRedeoly"   v-model="data.serviceRequitements"  label="2">加急（需额外收取费用）</el-radio>
                  </template>
                </td>
              </tr>
              <tr>
                <td colspan="4" style="overflow:visible;">如对报告有其他要求，请说明：
                    <input :readonly="isRedeoly"   v-model="data.reportRemark" style="width:80%">
                </td>
              </tr>
              <tr>
                <td colspan="4" style="overflow:visible;line-height: 35px;"><span style="color: red;">报告接收方&emsp;&emsp;</span> 
                  <template>
                        <el-radio :disabled="isRedeoly"    v-model="data.reportReceiving"  label="1">同委托人</el-radio>
                        <el-radio :disabled="isRedeoly"   v-model="data.reportReceiving"  label="2">同代理方</el-radio>
                        <el-radio :disabled="isRedeoly"   v-model="data.reportReceiving"  label="3">同交费方</el-radio>
                        <el-radio :disabled="isRedeoly"   v-model="data.reportReceiving"  label="4">不同于以上,请提供</el-radio>
                  </template>
                  <input    v-model="data.reportReceivingOther" size="60"  v-if="data.reportReceiving=='4'" :style="reportReceivingOtherStyle"   :readonly="(isRedeoly||data.reportReceiving!=='4')"   >
                </td>
              </tr>
          </table> 
         </div>
  
         <div class ='divcenter' style="margin-top:30px;font-size:23px;">
        9. 通用条款General Conditions
        </div>
         <div class ='divcenter' style="font-size:21px" >
            <p>a.委托人对所提供资料和样品来源的真实性和合法性负责；当生产企业与委托人不同，或由代理方填表时，本实验室不承担相关纠纷责任。</p>
            <p>b.若委托人需将检验检测报告用作仲裁或法律诉讼证据，必须在委托书中事先声明，并承担本实验室因配合司法机关取证而产生的人力、物力及交通等费用。</p>
            <p>c.此委托书是样品检验检测的依据，是客户获取报告和取回样品的凭证，填表人须确认所填信息真实、完整、准确，应对所填信息负责。如因信息错误导致已出报告的更改，或补充检验检测，须收回原报告，且酌情收取报告更改费或补充检验检测费用。</p>
            <p>d.本实验室按照委托书及相关标准要求开展检验检测活动，本委托检验检测的数据、结果仅适用于收到的样品，不代表委托人/生产企业其他同批次或同类产品质量。委托人不得利用报告从事虚假宣传和其他违法活动。</p>
            <p>e.依此委托书进行检验检测期间，如委托人/代理方提出终止检验检测，仍须承担已完成检验检测项目所产生的费用；如委托人提出变更检验检测要求，须重新提交委托书，实验室将以新的委托书作为最终依据并重新核算检验检测费用。</p>
            <p>f.为保证检验检测和技术服务的质量，委托人应尽可能详细的提供检验检测所需的各种资料和辅助工具（或配件），包括检验检测方案、所需的各种辅助工具（或配件）以及注意事项等。</p>
            <p>g.委托人如对检验检测样品保护有特别要求的，需在填委托书时特别提出。</p>
            <p>h.由于未预料的工作量增加不能按要求时间完成或因设备、人员或环境条件等暂时性原因而不具备能力开展委托的项目，我方可选择分包试验。若委托人不同意，请注明。</p>
            <p>i.本实验室对检验检测过程中获得或产生的客户有关信息和客户非公开性的资料予以保密。</p>
            <p>j.委托人若对报告有异议，需在收到报告之日起15个工作日内书面提出，否则视为接受；试验费用应在约定的时间内支付，逾期将向委托人收取违约金。</p>
            <p>k.如委托任务涉及赛宝CE认证申请，请填写委托合同中附表《CE认证申请信息表》的内容。</p>
         </div>
           <div class ='divcenter' style="font-size:20px" >
            <table>
               <tr>
                  <td  colspan="1" style="width:10%" ><span>委托人/代理方名称：<br>Client / Agent</span></td>
                  <td  colspan="4" style="width:40% ;border-right:0px"> 
                    <input :readonly="isRedeoly && data.signatureType!=='seeEdit'"   v-model="data.signer" style="width:100%" >
                  </td>
                  <td  colspan="1" style="width:10%">实验室名称：<br>Laboratory</td>
                  <td  colspan="4" style="width:40% ;border-right:0px">工业和信息化部电子第五研究所/中国赛宝实验室</td>
              </tr>
              <tr>
                <td colspan="1"  @click="imgDialog=!(isRedeoly && data.signatureType!=='seeEdit');"  style="width:3%">
                  <span class="color">经办人签章：<br>Stamp / Signature：</span></td>
                <td colspan="4"  @click="imgDialog=!(isRedeoly && data.signatureType!=='seeEdit');">
                  <span v-if="data.signaturelink===''" style='color:#CACACD'>请填写委托人、代理方，需要使用微信扫一扫签名(请点击此处)</span>
                  <img v-if="data.signaturelink" :src="data.signaturelink" style="width:150px;height:45px" />
                </td>
                <td colspan="1" >经办人签章：<br>Stamp / Signature：</td>
                <td colspan="4" >
                   <span v-if="data.authorizerLink===''||data.authorizerLink===null" >{{data.authorizer}}</span>
                   <img v-else  :src="data.authorizerLink" style="width:150px;height:45px" />
                </td>
              </tr>
              <tr>
                <td colspan="1"><span >日 &emsp; 期/Date：</span></td>
                <!-- <td colspan="4"> {{data.signaturetime}}<el-date-picker  :disabled="isRedeoly && data.signatureType!=='seeEdit'" v-model="data.signaturetime"  type="date" @change="data.signaturetime = initTime(data.signaturetime)"  placeholder="选择日期"></el-date-picker></td> -->
                <td colspan="4"> {{data.signaturetime}}</td>
                <td colspan="1">日 &emsp; 期/Date：</td>
                <td colspan="4"> {{data.authorizationTime}}</td>
              </tr>
          </table> 
         </div>  
          <div class ='divcenter' style="margin-top:40px;font-size:30px;padding-left:40%;">
          检验检测委托书填写说明
        </div>
         <div class ='divcenter' style="font-size:21px" >
          <p> 1 此文本用来统一本整机板块检验检测委托书形式；</p>
          <p>2生产者对应于制造商；生产企业对应于生产单位；</p>
          <p>3若有样品其他信息，如样品生产日期等，可在“型号规格/样品描述”栏目中填写；</p>
          <p>4 为确保委托信息的完整性，填写的信息不能简写，应以实际内容完整填写；</p>
         </div>
         <div class ='divcenter' style="font-size:21px" >
           
           <br> <br> <br> <br> <br> <br>
         </div>
  
          <div class ='divcenter'>
              <el-dialog title="授权人签名" :visible.sync="imgDialog" width="900px" :lock-scroll="false">
                <esign :token="data.timeStamp+data.conId" :imgDialog="imgDialog" @callback="receiveSignature" />
             </el-dialog>
           </div>
  
      <div style="position:fixed; top:0;  z-index:999;width:100%;   background-color: #3e4753;   color:rgb(218, 213, 213) ;  ont-size: 14px; text-align:center;" >
        <div style="width:1000px;min-width:1000px; margin:0 auto;font-size:23px ;margin-top:10px;margin-bottom:15px"> 
            <span>工业和信息化部电子第五研究所/中国赛宝实验室</span><br>
            <span >检验检测委托书</span><br>
             <div :style='data.signatureType==="see"?"display:block":"display:none"'  style="float:right;margin-top:-40px;margin-right:150px"> 
              <a  target="_blank" :href= '"https://fw.ceprei.com/service/conSgin/downPDF?timeStamp="+data.timeStamp+"&conId="+data.conId+"&fileName="+data.serialNumber+".pdf"'>
                <el-button  type="success"> 下载PDF</el-button>
              </a>
             </div> 
            <div style="float:right;margin-top:-40px;"> <el-button :disabled="isRedeoly && data.signatureType!=='seeEdit'"  type="primary" @click="sava('暂存');">&emsp;暂存&emsp;</el-button></div>
            <div style="float:right;margin-right:-150px;margin-top:-40px;"> <el-button :disabled="isRedeoly && data.signatureType!=='seeEdit'"   type="primary" @click="submit('提交');">&emsp;提交&emsp;</el-button></div>
            <div style="float:left;margin-left:18%;margin-top:-65px;"> <img style="width:70px;height:70px"  src='../../assets/favicon.png'></div>
        </div>
      </div>
      <div style="position:fixed;   bottom:0;  z-index:999;width:100%;    background-color: #3e4753;   color:rgb(218, 213, 213) ;  font-size: 14px " >
        <div style="width: 50%;margin:0 auto;padding-top:10px;min-width:730px">
            <div style="float: right; margin-top:6px" ><a href="https://www.ceprei.com/index.html" ><img src="https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png" ></a>  </div>
            <p  >Copyright © 2015. 中国赛宝实验室 All rights reserved. &nbsp;<i class="icon-home" ></i>&nbsp;广州市增城区朱村街朱村大道西78号 &nbsp;CEPREI-ZB-HT01-202102</p>
        </div>
    </div>
    </div>
  </template>
  <script>
  import { RequestGet, RequestPost,updateFIle,url } from '../../api/api'
  import esign from '@/components/esign' 
  import vueQr from 'vue-qr'
  import Table from '../nav1/Table.vue'
    export default {
    components: { esign ,vueQr},
      data() { 
         return {
          files:[],
            data:{
              serialNumber:"",
              type:"",
              clientName:"",
              clientContacts:"",
              clientAddr:"",
              clientPhone:"",
              clientMail:"",
              clientFax:"",
              producerName:"",
              producerContacts:"",
              producerAddr:"",
              producerPhone:"",
              producerMail:"",
              producerFax:"",
              factoryName:"",
              factoryContacts:"",
              factoryAddr:"",
              factoryPhone:"",
              factoryMail:"",
              factoryFax:"",
              agentName:"",
              agentContacts:"",
              agentAddr:"",
              agentPhone:"",
              agentMail:"",
              agentFax:"",
              payerName:"",
              payerContacts:"",
              payerAddr:"",
              payerPhone:"",
              payerMail:"",
              payerFax:"",
              paymentMethod:"",
              paymentMethodOrder:"",
              payDate:"",
              receiverName:"",
              receiverContacts:"",
              receiverAddr:"",
              receiverPhone:"",
              receiverMail:"",
              receiverFax:"",
              subData:[],
              simpleSubmitMethod:"",
              simpleSubmitMethodOrder:"",
              providePartsMaterial:"",
              basis:"",
              items:"",
              conditionsRequirements:"",
              agreeSubcontract:"",
              lawsuit:"",
              reportType:"",
              reportForm:"",
              cmaCnas:"",
              serviceRequitements:"",
              reportRemark:"",
              sampleHandle:"",
              sampleHandleOrder:"",
              authorizer:'',
              authorizationTime:'',
              signaturelink:'',
              signer:'',
              signaturetime:'',
              openId:'',
              userId :'',
              id:'',
              attachMent:[],
              authorizerLink:'',
              sampleHandleReturn: '',// 试验后样品处理(到付寄回)
              sampleHandleReturnOther: '',// 试验后样品处理(到付寄回)(其他)
              reportReceiving: '',// 报告接收方
              reportReceivingOther: ''// 报告接收方(其他)
             },
            inputStyle:'',
            sampleInputStyle:'',
            sampleMethodInputStyle:'',
            sampleHandleReturnOtherStyle:'',
            reportReceivingOtherStyle:'',
            imgDialog:false,
            isRedeoly:false,
            isShow:true
        };
      },
      watch : {
          "data.paymentMethod":function(val) {
              if(this.data.paymentMethod!=='3'){
                 this.data.paymentMethodOrder=''
                 this.inputStyle="border:none"
              }else{
                this.inputStyle="border:solid red;border-left:0px;border-top:0px;border-right:0px; height:30px;margin-top:-10px;margin-left:-30px; margin-right:30px;"
              }
          },  
          "data.simpleSubmitMethod":function(val) {
              if(this.data.simpleSubmitMethod!=='3'){
                 this.data.simpleSubmitMethodOrder=''
                 this.sampleInputStyle="border:none"
              }else{
                this.sampleInputStyle="border:solid red ;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:30px;;outline:medium;"
              }
          },
           "data.sampleHandle":function(val) {
              if(this.data.sampleHandle!=='6'){
                 this.data.sampleHandleReturn=''
              }else{
                this.sampleMethodInputStyle="border:solid red;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:20px;"
              }
          },
          "data.sampleHandleReturn":function(val) {
              if(this.data.sampleHandleReturn!=='5'){
                 this.data.sampleHandleReturnOther=''
              }else{
                this.sampleHandleReturnOtherStyle="border:solid red;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:25px;outline: medium;"
              }
          },
          "data.reportReceiving":function(val) {
              if(this.data.reportReceiving!=='4'){
                 this.data.reportReceivingOther=''
                 if(this.data.reportReceiving=='1'){
                    this.data.receiverName=this.data.clientName;
                    this.data.receiverAddr=this.data.clientAddr;
                    this.data.receiverContacts=this.data.clientContacts;
                    this.data.receiverPhone=this.data.clientPhone;
                    this.data.receiverMail=this.data.clientMail;
                    this.data.receiverFax=this.data.clientFax;
                 }else if(this.data.reportReceiving=='2'){
                    this.data.receiverName=this.data.agentName;
                    this.data.receiverAddr=this.data.agentAddr;
                    this.data.receiverContacts=this.data.agentContacts;
                    this.data.receiverPhone=this.data.agentPhone;
                    this.data.receiverMail=this.data.agentMail;
                    this.data.receiverFax=this.data.agentFax;
                  }else if(this.data.reportReceiving=='3'){
                    this.data.receiverName=this.data.payerName;
                    this.data.receiverAddr=this.data.payerAddr;
                    this.data.receiverContacts=this.data.payerContacts;
                    this.data.receiverPhone=this.data.payerPhone;
                    this.data.receiverMail=this.data.payerMail;
                    this.data.receiverFax=this.data.payerFax;
                  }
              }else{
                    this.data.receiverName='';
                    this.data.receiverAddr='';
                    this.data.receiverContacts='';
                    this.data.receiverPhone='';
                    this.data.receiverMail='';
                    this.data.receiverFax='';
                    this.reportReceivingOtherStyle="border:solid red;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:25px;outline: medium;"
              }
          },
         
      },
      created:function(){
          document.title = '中国赛宝实验室装备与整机研究部委托书';
          let prames='';
          try{
               prames =  this.queryToObj(this.$route.fullPath)
          }catch(e){
            this.isShow=false
            this.$alert('无效地址,请确认',{dangerouslyUseHTMLString: true,lockScroll:false})
            throw e;
          }
          if(prames!==''){
            this.getData( prames);
          }
      },
      methods: {
       async getData(requestParam){
           await  RequestPost("/conSgin/get",requestParam).then(response => {
                 if(response.data!='{}'){
                    this.data = JSON.parse(response.data);
                 }
                 this.data.userId = this.data.userId;
                 this.data.id = this.data.id;
                 this.data.reportType = this.getArr2(this.data.reportType);
                 this.data.reportForm = this.getArr2(this.data.reportForm);
                 this.data.cmaCnas = this.getArr2(this.data.cmaCnas);
                 if(this.data.cmaCnas.length===0){
                   this.data.cmaCnas.push('无');
                 }

               if(this.data['cmaCnasOther']===undefined){
                 this.data['cmaCnasOther']='';
               }


                 this.data.pageTye=requestParam.pageTye
                 this.data.conId=requestParam.conId
                 this.data.timeStamp=requestParam.timeStamp
                 this.data.clientDept=requestParam.clientDept
                 this.data.authorizer=requestParam.authorizer===undefined?'':requestParam.authorizer
                 this.data.signaturetime=this.data.signaturetime===''?this.initTime(new Date()):this.data.signaturetime
                 this.data.signer=  this.data.signer!==''? this.data.signer:(this.data.agentName!=''&& this.data.agentName!=undefined) ? this.data.agentName:this.data.clientName
                    // this.data.signatureType='edit'
                this.isRedeoly = (this.data.signatureType==='see'||this.data.signatureType==='seeEdit')?true:false

             // console.log("data.authorizerLink = " + this.data.authorizerLink);
               
              }).catch(error => {
                console.log(error);
              })
        },
        getArr2(d){
            if(d===''||d===undefined)
                return [];
            return d.split(',');
        },
        receiveSignature (img){      // 接收组件的签名
            this.data.signaturelink =img.imgUrl;
            this.data.openId = img.openId
            console.log(this.data.openId);
            this.imgDialog = false;
        },
        queryToObj(base64str) {
         
          var decode = escape(atob(decodeURIComponent( base64str.split('?')[1])));
         
          var str =   decodeURIComponent(decodeURIComponent(decode));
          const res = {}
          str.split('&').forEach(paramStr => {
            const arr = paramStr.split('=')
            const key = arr[0]
            const value = arr[1]
            res[key] = value
          })
          return res  
      },
       upload(){},
       removeFile(file, fileList){
         this.files=[];
         fileList.forEach(e => {
            this.files.push(e.raw);
            console.log(e.raw.name);
          })
       },
       beforeAvatarUpload(file) {
          //console.log(file.name);
          this.files.push(file);
          return true;
      },
     deleteFile(row){
      this.$confirm('此操作将暂时删除该文件,提交或暂存以后将永久性删除该文件,是否继续?', '提示', {
            lockScroll:false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            row.type='delete'
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
         console.log(row);
     },
  
  
        sava(type){
          // let data = JSON
          let data  = JSON.parse(JSON.stringify(this.data)); 
          data.commitType=type;
          let jsonStrData =  JSON.stringify(data);
          let formData = new FormData()
          formData.append('jsonStrData', jsonStrData)
          let isDyMaxFileSize=false;
          let allSize=0;
          this.files.forEach(file => {
            if(file.size > 10485760){
              isDyMaxFileSize = true
            }
            allSize+=file.size ;
            formData.append('files', file);
          })

          if(isDyMaxFileSize){
            this.$message({ message:'单个文件不可大于10M', type: "error" });
            return;
          }
          if(allSize>104857600){
            this.$message({ message:'全部文件不可大于100M', type: "error" });
            return;
          }
         
          
          updateFIle(url+'/conSgin/save',formData).then(response => {
              var obj=response['data'];
              var code=response['code'];
              var message=response['message'];
              if(code!=='0000'){
                this.$alert(type+'失败'+message,{dangerouslyUseHTMLString: true,lockScroll:false})
              }else{
                this.querenkuan(type)
              }
            }).catch(error => {
              console.log(error);
              this.$alert(type+'失败',{dangerouslyUseHTMLString: true,lockScroll:false})
            })
        },
        async querenkuan(type){
          await this.$confirm(type+"成功", '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              showClose:false,
              type: 'success'
            }).then(() => {
              location.reload();
            }).catch(() => {
              location.reload();
            });
      },
        
        // },
        // 提交
        submit  (type) {
          let msg =null
          if(this.data.signatureType==='seeEdit'){
            msg= this.submitVerifySeeEdit();
          }else if(this.data.signatureType==='edit'){
             msg= this.submitVerify();
          }  
          if(msg!==null){
            this.$message({ message:msg, type: "error" });
            return ;
          }
          this.sava(type);
        },
         
        initTime(date){
         if(typeof(date)=='string')
          return date;
          let year = date.getFullYear(); // 年
          let month = date.getMonth() + 1; // 月
           month = month < 10 ? "0" + month : month; // 如果只有一位，则前面补零
          let day = date.getDate(); // 日
          day = day < 10 ? "0" + day : day; // 如果只有一位，则前面补零
          return `${year}-${month}-${day}`;
      },
  
  
  
       submitVerify  () {
              let msg = ""; 
              //*********************************************************************************************************** */
              let d = this.data;
                if(d.clientName==='')
                  return '请填写委托人Client-请填写名称Name';
                if(d.clientAddr==='')
                  return '请填写委托人Client-请填写地址Address';
                if(d.clientContacts==='')
                  return '请填写委托人Client-请填写联系人Contact';
                if(d.clientPhone==='')
                return '请填写委托人Client-请填写电话Phone';
                if(d.clientMail==='')
                return '请填写委托人Client-请填写邮箱E-mail';
  
                if(d.payerName==='')
                  return '请填写交费方Payer-名称Name';
                if(d.payerAddr==='')
                  return '请填写交费方Payer-地址Address';
                if(d.payerContacts==='')
                  return '请填写交费方Payer-联系人Contact';
                if(d.payerPhone==='')
                  return '请填写交费方Payer-电话Phone';
                if(d.payerMail==='')
                  return '请填写交费方Payer-邮箱E-mail';
                if(d.paymentMethod==='')
                  return '请选择交费方Payer-付款方式';
                if(d.paymentMethod==='3'&&d.paymentMethodOrder==='')
                  return '请填写交费方Payer-其他付款方式';
                if(d.payDate==='')
                  return '-请选择交费方Payer-付款日期';
  
                if(d.simpleSubmitMethod==='')
                  return '请选择样品信息- 样品寄送方式';
                if(d.simpleSubmitMethod==='3'&& d.simpleSubmitMethodOrder==='')
                  return '请填写样品信息- 样品其他接收方式';
                if(d.subData.length!==0 ){
                    for(var i = 0; i < d.subData.length; i++) {
                        let element = d.subData[i];
                        if(element.name===''){
                            return '请填写样品名称';
                        } 
                        if(element.specs===''){
                            return '请填写样品型号';
                        } 
                        if(element.kind===''){
                            return '请填写样品规格';
                        } 
                        // if(element.describe===''){
                        //     return '请填写样品描述';
                        // } 
                        if(element.number===''){
                            return '请填写样品数量';
                        } 
                        if(element.number<0){
                            return '请填写正确样品数量,样品数量不可小于1';
                        } 
                  }
              } 
              if(d.sampleHandle==='')
                return '请选择样品试验后样品处理Sample Handling';
                
              if(d.sampleHandle==='6'&& d.sampleHandleReturn==='')
                return '请选着样品处理方式到付寄回的子选项';
              if(d.sampleHandle==='6'&& d.sampleHandleReturn==='5'&&d.sampleHandleReturnOther==='')
                return '请选着样品处理方式到付寄回的的相关信息';
  
              if(d.basis==='')
                return '请填写检验检测要求- 检验检测依据Testing Basis';
              if(d.items==='')
                return '请填写检验检测要求- 检验检测项目Test Items';
              if(d.conditionsRequirements==='')
                return '请填写检验检测要求-检验检测条件及要求Technical Conditions';
              if(d.agreeSubcontract==='')
                return '请选择检验检测要求-如需分包';
              if(d.lawsuit==='')
                 return '请填写检验检测要求-该检验是否与诉讼有关';
  
              // if(d.reportType.length===0)
              //   return '请选择报告要求Report Requirements- 报告版本';
              // if(d.reportForm.length===0)
              //   return '请选择报告要求Report Requirements- 报告形式';
              // if(d.reportReceiving==='4' && d.reportReceivingOther==='')
              //    return '请选择报告要求Report Requirements- 报告其他接收方式';
              // if(d.serviceRequitements==='')
              //   return '请选择报告要求Report Requirements- 服务要求';
              
           
           
              return this.submitVerifySeeEdit();
          }, 
  
           submitVerifySeeEdit  () {
              let msg = ""; 
              //*********************************************************************************************************** */
              let d = this.data;
              if(d.signer==='')
                return '填写委托人/代理方名称';
              if(d.signaturelink==='')
                return '请使用微信扫一扫签名';
              if(d.signaturetime==='')
                return '请选择委托日期';
              return null;
          }
  
      }
      
  
      
    }
  </script>
   <style type="text/css">
   #neirong div table { 
      border-collapse:collapse; 
      border:2px solid black; 
      width:100%;
     margin-top: 40px;
     margin-left: 5px;
     font-size: 16px;
     } 
    #neirong div>table>tr>td { 
      border:2px solid black;
      padding-left: 5px;
      font-weight:bold ;
      white-space: nowrap;
      overflow:hidden;
     } 
     #neirong div>table>tr>th { 
      border:2px solid black;
     } 
     #neirong div>table>tr>td>input{
        border:none; 
        outline:medium; 
       font-size: 18px;
     }
      .cbo{
        width:70%;
        margin:0 auto; 
        margin-top:0px;
        min-width:1000px;
     }
     #tableIndex table{
         margin-top:0px;
     }
    #tableIndex textarea{
        border:none; 
     }
    .color{
      color:red
    }
     .divcenter{
         width:70%;
        margin:0 auto; 
        margin-top:0px;
        min-width:1000px;
     }
    .divcenter table{
         border-collapse:collapse; 
         border:2px solid black; 
         width:100%;
         margin-top:0px
     }
     .divcenter table td {
        border:2px solid black;
        padding-left: 5px;
        font-weight:bold ;
        white-space: nowrap;
        overflow:hidden;
     }
     .divcenter table td input{
        border:none; 
        outline:medium; 
       font-size: 18px;
     }
     .divcenter textarea{
        border:none; 
        font-size:19px
     }
   </style>


// WEBPACK FOOTER //
// emailConSign.vue?945e3f72